/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DryRunRule } from './DryRunRule';
import {
    DryRunRuleFromJSON,
    DryRunRuleFromJSONTyped,
    DryRunRuleToJSON,
    DryRunRuleToJSONTyped,
} from './DryRunRule';

/**
 * Which rule would win for one configured action, and with what parameters.
 * @export
 * @interface DryRunAction
 */
export interface DryRunAction {
    /**
     * 
     * @type {string}
     * @memberof DryRunAction
     */
    transitionAction: string;
    /**
     * 
     * @type {string}
     * @memberof DryRunAction
     */
    actionName: string;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunAction
     */
    isRegistered: boolean;
    /**
     * 
     * @type {string}
     * @memberof DryRunAction
     */
    matchedRule: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DryRunAction
     */
    extraParams: { [key: string]: any; };
    /**
     * 
     * @type {Array<DryRunRule>}
     * @memberof DryRunAction
     */
    rules: Array<DryRunRule>;
}

/**
 * Check if a given object implements the DryRunAction interface.
 */
export function instanceOfDryRunAction(value: object): value is DryRunAction {
    if ((!('transitionAction' in (value as Record<string, any>)) && !('transition_action' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionAction'] === undefined && (value as Record<string, any>)['transition_action'] === undefined)) return false;
    if ((!('actionName' in (value as Record<string, any>)) && !('action_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionName'] === undefined && (value as Record<string, any>)['action_name'] === undefined)) return false;
    if ((!('isRegistered' in (value as Record<string, any>)) && !('is_registered' in (value as Record<string, any>))) || ((value as Record<string, any>)['isRegistered'] === undefined && (value as Record<string, any>)['is_registered'] === undefined)) return false;
    if ((!('matchedRule' in (value as Record<string, any>)) && !('matched_rule' in (value as Record<string, any>))) || ((value as Record<string, any>)['matchedRule'] === undefined && (value as Record<string, any>)['matched_rule'] === undefined)) return false;
    if ((!('extraParams' in (value as Record<string, any>)) && !('extra_params' in (value as Record<string, any>))) || ((value as Record<string, any>)['extraParams'] === undefined && (value as Record<string, any>)['extra_params'] === undefined)) return false;
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function DryRunActionFromJSON(json: any): DryRunAction {
    return DryRunActionFromJSONTyped(json, false);
}

export function DryRunActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunAction {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionAction': json['transition_action'],
        'actionName': json['action_name'],
        'isRegistered': json['is_registered'],
        'matchedRule': json['matched_rule'],
        'extraParams': json['extra_params'],
        'rules': ((json['rules'] as Array<any>).map(DryRunRuleFromJSON)),
    };
}

export function DryRunActionToJSON(json: any): DryRunAction {
    return DryRunActionToJSONTyped(json, false);
}

export function DryRunActionToJSONTyped(value?: DryRunAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition_action': value['transitionAction'],
        'action_name': value['actionName'],
        'is_registered': value['isRegistered'],
        'matched_rule': value['matchedRule'],
        'extra_params': value['extraParams'],
        'rules': ((value['rules'] as Array<any>).map(DryRunRuleToJSON)),
    };
}

